// import React from "react";
// import { Doughnut } from "react-chartjs-2";
// import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

// Chart.register(ArcElement, Tooltip, Legend);

// const defaultColors = [
//   "#4e73df",
//   "#1cc88a",
//   "#36b9cc",
//   "#f6c23e",
//   "#e74a3b",
//   "#858796",
//   "#5a5c69",
//   "#fd7e14",
//   "#20c997",
//   "#6f42c1"
// ];

// const DonutChart = ({ data = [], colors }) => {
//   const chartData = {
//     labels: data.map((d) => d.label),
//     datasets: [
//       {
//         data: data.map((d) => d.value),
//         backgroundColor: colors || defaultColors.slice(0, data.length),
//         borderWidth: 1,
//       },
//     ],
//   };

//   const options = {
//     cutout: "60%",
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         enabled: true,
//       },
//       datalabels: {
//         display: false, // <--- This disables datalabels even if plugin is registered
//       },
//     },
//     responsive: true,
//     maintainAspectRatio: false,
//   };
//   return (
//     <div style={{ width: "180px", height: "180px" , margin : "auto"}}>
//       <Doughnut data={chartData} options={options} />
//     </div>
//   );
// };

// export default DonutChart; 

import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend);

const defaultColors = [
  "#4e73df",
  "#1cc88a",
  "#36b9cc",
  "#f6c23e",
  "#e74a3b",
  "#858796",
  "#5a5c69",
  "#fd7e14",
  "#20c997",
  "#6f42c1",
];

const DonutChart = ({
  data = [],
  colors,
  onItemClick, // 1. YE ADD KARNA HAI
}) => {
  const chartData = {
    labels: data.map((d) => d.label),

    datasets: [
      {
        data: data.map((d) => d.value),
        backgroundColor:
          colors || defaultColors.slice(0, data.length),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    cutout: "60%",

    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
        enabled: true,
      },

      datalabels: {
        display: false,
      },
    },

    responsive: true,
    maintainAspectRatio: false,

    // 2. YE ADD KARNA HAI
    onClick: (event, elements) => {
      if (!elements?.length) {
        return;
      }

      const index = elements[0].index;
      const clickedItem = data[index];

      console.log("DONUT CLICKED:", clickedItem);

      if (clickedItem && onItemClick) {
        onItemClick(clickedItem);
      }
    },

    // 3. Cursor pointer ke liye
    onHover: (event, elements) => {
      if (event?.native?.target) {
        event.native.target.style.cursor =
          elements?.length ? "pointer" : "default";
      }
    },
  };

  return (
    <div
      style={{
        width: "180px",
        height: "180px",
        margin: "auto",
      }}
    >
      <Doughnut
        data={chartData}
        options={options}
      />
    </div>
  );
};

export default DonutChart;